
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { IoIosClose } from "react-icons/io";

import { Container, Close, BoxImage, BoxInfor, ItemMenu, BoxMenu } from "./styled";
import { useState } from 'react';
import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { translations } from '../../../../utils/language';
import { ArrowDownOnSquareIcon, ArrowPathIcon, ArrowPathRoundedSquareIcon, ArrowTopRightOnSquareIcon, CloudArrowDownIcon, DocumentIcon, EnvelopeIcon, PaperClipIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useHistory } from 'react-router-dom';


const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: "white",
        padding: "0px",
        margin: "0px",
        borderRadius: "10px"
    },
    overlay: {
        backgroundColor: "rgba(10,23,55,0.5)",
        zIndex: "99999999"
    }
};



const ModalMenuCad = (props) => {

    const dispatch = useDispatch()
    const language = useSelector((state) => state.reducerLanguage);

    return (
        <Modal
            isOpen={props.visibleModalMenuCad}
            style={customStyles}
            ariaHideApp={false}
            onRequestClose={() => { props.setVisibleModalMenuCad(false) }}
        >
            <Container>
                <Close onClick={() => { props.setVisibleModalMenuCad(false) }}><IoIosClose size={25} color={"gray"} /></Close>
                <BoxMenu>

                    <Item
                        image={<DocumentIcon style={{ width: "32px" }} />}
                        action={() => {
                            props.setVisibeModalAnexoNew(true)
                            props.setVisibleModalMenuCad(false)
                        }}
                        item={props.item}
                        title={translations["medias-arquivo"][language.data]}
                        desc={translations["medias-menu-arquivos-desc"][language.data]} />

                    <Item
                        image={<ArrowTopRightOnSquareIcon style={{ width: "32px" }} />}
                        action={() => {
                            props.setVisibleModalCadLink(true)
                            props.setVisibleModalMenuCad(false)
                        }}
                        item={props.item}
                        title={translations["medias-menu-links"][language.data]}
                        desc={translations["medias-menu-links-desc"][language.data]} />

                </BoxMenu>
            </Container>
        </Modal>
    )
}

export default ModalMenuCad


const Item = (props) => {

    const dispatch = useDispatch()

    useEffect(() => {
        //console.log("props_", props)
    }, [props])


    const [hover, setHover] = useState(false)


    return (
        <ItemMenu onClick={() => { props.action() }} hover={hover} onMouseLeave={() => { setHover(false) }} onMouseEnter={() => { setHover(true) }}>
            <BoxImage hover={hover}>
                {props.image}
            </BoxImage>
            <BoxInfor>
                <label>{props.title}</label>
                <p>{props.desc}</p>
            </BoxInfor>
        </ItemMenu>
    )
}

